import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <span className="w-16 h-16 rounded-2xl bg-primary-500 flex items-center justify-center text-foreground-950">
        <i className="ri-movie-2-line text-3xl" aria-hidden="true"></i>
      </span>
      <p className="mt-6 font-heading text-6xl md:text-7xl text-foreground-950">404</p>
      <h1 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-950">这一页走丢了</h1>
      <p className="mt-3 text-sm md:text-base text-foreground-700 max-w-md leading-7">
        你访问的页面可能已被移动或不存在。返回首页，继续找你想看的动漫全集资源吧。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-foreground-950 text-sm font-medium hover:bg-primary-400 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line" aria-hidden="true"></i> 返回首页
        </Link>
        <Link
          to="/library"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 text-foreground-800 text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap"
        >
          进入资源库
        </Link>
      </div>
    </main>
  );
}